import { useTranslation } from "react-i18next";
import PageBreadcrumb from "../../../../shared/ui/common/PageBreadCrumb";
import PageMeta from "../../../../shared/ui/common/PageMeta";
import TherapeuticPlanAddForm from "../../../../modules/therapeutic_plan/ui/components/AddForm/TherapeuticPlanAddForm";
import { useTherapist } from "../../../../context/TherapistProvider";

export default function AddTherapeuticPlan() {
  const { t } = useTranslation();
  const { therapist } = useTherapist();

  return (
    <div>
      <PageMeta />
      <PageBreadcrumb pageTitle={t("therapeuticPlan.addNewPageTitle")} />
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <div className="col-span-full">
          <TherapeuticPlanAddForm therapistID={therapist?.id ?? ""} />
        </div>
      </div>
    </div>
  );
}
